// Shared auth context + hook. Split out from auth.tsx so the Clerk provider can
// live in a lazily-loaded chunk (auth-clerk.tsx) and still publish into the same
// context instance, with no circular import back onto auth.tsx.
import { createContext, useContext } from "react";
import type { MeDto, Capability } from "@arcline/shared";

export interface AuthCtx {
  me: MeDto | null;
  loading: boolean;
  // Clerk mode: authenticated with Clerk but no matching ArcLine account.
  signedInNoAccess?: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
  can: (cap: Capability) => boolean;
}

export const Ctx = createContext<AuthCtx | null>(null);

export function useAuth(): AuthCtx {
  const v = useContext(Ctx);
  if (!v) throw new Error("useAuth outside AuthProvider");
  return v;
}
